import { render, staticRenderFns } from "./BrandQuestion.vue?vue&type=template&id=3e049425"
import script from "./BrandQuestion.vue?vue&type=script&lang=js"
export * from "./BrandQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports